<template v-if="success">      
  <div  v-if="success" class="row">
    <div class="col-sm-3"></div>
    <div class="col-sm-6 text-center">
       <div class="alert alert-success" role="alert">
           <p>Your Guest Pass has been linked to your Hunter & Gold account.</p>
           <p>At the venue you must show the QR Code screen, in your Hunter & Gold App.</p>
           <p>Photo ID maybe requested and entry is at the discretion of
              management. If you have any issues with your app, please contact client@huntergold.com.</p>
        </div>
      </div>   
    <div class="col-sm-3"></div>
  </div>
  <div v-else class="row">
    <div class="col-sm-3"></div>
    <div class="col-sm-6 text-center">
      <h5>It looks like the page you're looking for doesn't exist.</h5>
    </div>
    <div class="col-sm-3"></div>
  </div>
</template>
<script>
export default {
  name: "LinkedGuestPass",

  props: ["linked"],

  data() {
    return {
      success: (this.linked.toLowerCase() === 'true')
    };
  },
};
</script>

<style>
</style>